import React from 'react';
import memoizeOne from 'memoize-one';
import { camelCaseEmptyStringRecursive } from '../../../services/utils';
import PayrollActions from './PayrollActions';
import { DatatableEmployeeName } from '../../../components';

const PayrollColumns = memoizeOne(handleClick => [
  {
    name: 'Acciones',
    selector: 'actions',
    cell: item => <PayrollActions handleClick={handleClick} item={camelCaseEmptyStringRecursive(item)} />,
    id: 'actions',
    grow: '1',
    style: {
      justifyContent: 'center',
      textAlign: 'center'
    }
  },
  {
    name: 'Trabajador',
    id: 'full_name',
    selector: 'full_name',
    grow: '1',
    cell: item => <DatatableEmployeeName item={item} withPhoto={false} />,
    sortable: true
  },
  {
    name: 'Centro de Costo',
    selector: 'cost_center',
    cell: item => item.cost_center_name,
    grow: '1',
    sortable: true
  },
  {
    name: 'Días trabajados',
    id: 'worked_days',
    cell: () => '0',
    grow: '1',
    sortable: false
  },
  {
    name: 'Sueldo Base',
    id: 'salary_amount',
    cell: () => '$ 0.00',
    grow: '1',
    sortable: false
  },
  {
    name: 'Total imponible',
    id: 'assets_taxable_total',
    cell: () => '$ 0.00',
    grow: '1',
    sortable: false
  },
  {
    name: 'Total haberes',
    id: 'assets_total',
    cell: () => '$ 0.00',
    grow: '1',
    sortable: false
  },
  {
    name: 'Desctos. Legales',
    id: 'discounts_total_legal',
    cell: () => '$ 0.00',
    grow: '1',
    sortable: false
  },
  {
    name: 'Total Desctos.',
    id: 'discounts_total',
    cell: () => '$ 0.00',
    grow: '1',
    sortable: false
  },
  {
    name: 'Líquido a Pagar',
    id: 'liquid',
    cell: () => '$ 0.00',
    grow: '1',
    sortable: false
  }
]);

export default PayrollColumns;
